import { render, staticRenderFns } from "./ImageLoader.vue?vue&type=template&id=924fe270&scoped=true&"
import script from "./ImageLoader.vue?vue&type=script&lang=ts&"
export * from "./ImageLoader.vue?vue&type=script&lang=ts&"
import style0 from "./ImageLoader.vue?vue&type=style&index=0&id=924fe270&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924fe270",
  null
  
)

export default component.exports